export const animationSettings = {
  fs_add: {
    'default': ['static'],
    'STATE:IN:FS-ADD': ['play', true],
  },
  fs_start: {
    'default': ['static'],
    'STATE:IN:FS-START': ['play', false, 'start', { name: 'LOOP', delay: 0.8 }],
    'LOOP': ['play', true, 'loop'],
  },
}
